import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-14 items-center">
          {/* Left - Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative">
              <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Malaysian%20youth%20group%20engaged%20in%20collaborative%20learning%20activity%20in%20bright%20community%20space%20with%20wooden%20tables%2C%20warm%20natural%20light%2C%20genuine%20smiles%2C%20diverse%20participants%2C%20modern%20yet%20humble%20setting%2C%20uplifting%20atmosphere%2C%20soft%20cream%20and%20earth%20tones&width=900&height=675&seq=about-main-2026&orientation=landscape"
                  alt="Youth learning together at PERTUBUHAN INSAN PERWIRA"
                  title="INSAN PERWIRA - Community Programs"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Floating stat badge */}
              <div className="absolute -bottom-3 -right-3 md:-bottom-5 md:-right-5 bg-accent-500 rounded-xl px-4 py-2.5 md:px-5 md:py-3 shadow-sm">
                <p className="text-background-50 font-heading font-bold text-xl md:text-2xl leading-none">500+</p>
                <p className="text-background-50/80 text-xs mt-0.5">Youth Empowered</p>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block text-xs font-semibold tracking-wider uppercase text-primary-600 mb-3">
              About Our Organization
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-tight mb-4">
              {aboutContent.title}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              {aboutContent.subtitle}
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-7">
              {aboutContent.description}
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5">
              {aboutContent.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="text-center p-3 md:p-4 rounded-xl bg-background-100"
                >
                  <p className="font-heading font-bold text-xl md:text-2xl text-primary-500 mb-1">
                    {stat.value}
                  </p>
                  <p className="text-foreground-500 text-xs md:text-sm">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}